<template>
  <modal :show.sync="showModal" @close="handleClose" header-classes="justify-content-center">
    <h4 slot="header" class="title title-up">
      Add New Bible Study Plan
    </h4>
    <p v-if="seriesOptionError === true" class="danger">
      You must select a bible study series.
    </p>
    <el-select
      v-model="series"
      value-key="id"
      placeholder="Select series..."
      style="width: 100%"
      @change="seriesChanged"
    >
      <el-option
        v-for="item in getSeriesOptions()"
        :key="item.value.id"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <br><br>
    <p v-if="materialOptionError === true" class="danger">
      You must select a bible study material.
    </p>
    <el-select
      v-if="!!series"
      v-model="material"
      value-key="id"
      placeholder="Select bible study..."
      style="width: 100%"
      @change="materialChanged"
    >
      <el-option
        v-for="item in getMaterialsOptions()"
        :key="item.value.id"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <br><br>
    <p v-if="titleError === true" class="danger">
      A Title is required.
    </p>
    <fg-input
      placeholder="Title"
      v-model="title"
      @value="title"
      @input="titleChanged"
    />
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" @click.native="handleSave">
        Save
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState, vuex } from 'vuex';
import Modal from '../UIComponents/Modal';

function validateTitle(title) {
    return !!title;
}

export default {
    name: 'RNewBspModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            title: '',
            series: '',
            material: '',
            titleError: false,
            seriesOptionError: false,
            materialOptionError: false,
        };
    },
    computed: {
        ...mapState({
            materials: (state) => state.BibleStudyPlans.materials
        }),
    },
    methods: {
        isFormValid() {
            if (!this.series) {
                this.seriesOptionError = true;
                return false;
            }

            if (!this.material) {
                this.materialOptionError = true;
                return false;
            }

            if (!validateTitle(this.title)) {
                this.titleError = true;
                return false;
            }

            return true;
        },
        handleSave() {
            if (!this.isFormValid()) {
                return;
            }
            this.$emit('save', {
                title: this.title,
                materialId: this.material.id
            });

            this.handleClose();
        },
        handleClose() {
            this.onExit();
            this.$emit('close');
        },
        onExit() {
            this.title = '';
            this.series = '';
            this.material = '';
            this.titleError = false;
            this.materialOptionError = false;
            this.seriesOptionError = false;
        },
        getSeriesOptions() {
            if (!this.materials) { return []; }

            // so this is super hard to read and understand but what I am doing is removing duplicates
            // from the list of series names.
            const options = (m) => m.filter((v, i) => m.map((j) => j.name).indexOf(v.name) === i);

            return options(this.materials.map((v) => v.series)).map((seriesListItem, i) => ({
                value: seriesListItem,
                label: seriesListItem.name
            })).sort((a, b) => a.value.sort_order - b.value.sort_order);
        },
        getMaterialsOptions() {
            if (!this.materials || !this.series) { return []; }

            const seriesFilter = (m) => m.filter((v, i) => v.series.name === this.series.name);

            return seriesFilter(this.materials).map((material, i) => ({
                value: material,
                label: material.title
            })).sort((a, b) => a.value.sort_order - b.value.sort_order);
        },
        seriesChanged(value) {
            this.seriesOptionError = false;
        },
        materialChanged(material) {
            this.title = material.title;
            this.materialOptionError = false;
        },
        titleChanged(value) {
            this.titleError = false;
        }
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
        }
    },
};
</script>
